var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    `tooltip`,
    _vm.isOpen && `tooltip--open`,
    _vm.isDark && `tooltip--dark`,
    _vm.isOneLine && `tooltip--one-line`,
    _vm.position === `top-center` && `tooltip--center`,
    _vm.position === `top-right` && `tooltip--right`,
    _vm.position === `below-left` && `tooltip--below`,
    _vm.position === `below-center` && `tooltip--center tooltip--below`,
    _vm.position === `below-right` && `tooltip--right tooltip--below`,
    _vm.position === `right-top` && `tooltip--right-top`,
    _vm.position === `left-top` && `tooltip--left-top`,
  ],attrs:{"aria-describedby":"tooltip__text_id","tabindex":"0"}},[(_vm.isBold)?_c('strong',[_vm._v(_vm._s(_vm.label))]):_c('span',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"tooltip__wrapper",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"tooltip__text",attrs:{"id":"tooltip__text_id"}},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }